function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 159.929,
  cy: 136.929,
  r: 99.9295,
  fill: "#40444A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M173.085 60.251C169.158 60.251 74.843 60.251 65.994 60.251C62.5618 60.251 59.7832 63.0296 59.7832 66.4576V237.793C59.7832 241.221 62.5618 244 65.994 244H173.085C176.517 244 179.296 241.221 179.296 237.793V66.4576C179.296 63.0296 176.517 60.251 173.085 60.251Z",
  fill: "#292F35"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0651 244H65.994C62.5618 244 59.7832 241.221 59.7832 237.793V66.4576C59.7832 63.0296 62.5618 60.251 65.994 60.251H79.0651C75.6329 60.251 72.8542 63.0296 72.8542 66.4576V237.793C72.8542 241.223 75.6329 244 79.0651 244Z",
  fill: "#40444A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M158.938 78.4507H80.1391C77.4195 78.4507 75.2129 80.6573 75.2129 83.3797V110.846C75.2129 113.568 77.4195 115.776 80.1391 115.776H158.938C161.657 115.776 163.864 113.568 163.864 110.846V83.3797C163.864 80.6573 161.657 78.4507 158.938 78.4507Z",
  fill: "#40444A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M158.938 133.638H80.1391C77.4195 133.638 75.2129 135.846 75.2129 138.569V166.033C75.2129 168.756 77.4195 170.964 80.1391 170.964H158.938C161.657 170.964 163.864 168.756 163.864 166.033V138.569C163.864 135.846 161.657 133.638 158.938 133.638Z",
  fill: "#40444A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M158.938 188.828H80.1391C77.4195 188.828 75.2129 191.034 75.2129 193.757V221.223C75.2129 223.945 77.4195 226.152 80.1391 226.152H158.938C161.657 226.152 163.864 223.945 163.864 221.223V193.757C163.864 191.034 161.657 188.828 158.938 188.828Z",
  fill: "#40444A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M92.1777 115.776H80.1411C77.4215 115.776 75.2148 113.568 75.2148 110.846V83.3797C75.2148 80.6573 77.4215 78.4507 80.1411 78.4507H92.1777C89.4594 78.4507 87.2514 80.6573 87.2514 83.3797V110.846C87.2514 113.568 89.4594 115.776 92.1777 115.776Z",
  fill: "#4F555C"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M92.1777 170.964H80.1411C77.4215 170.964 75.2148 168.756 75.2148 166.033V138.569C75.2148 135.846 77.4215 133.638 80.1411 133.638H92.1777C89.4594 133.638 87.2514 135.846 87.2514 138.569V166.033C87.2514 168.756 89.4594 170.964 92.1777 170.964Z",
  fill: "#4F555C"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M92.1777 226.152H80.1411C77.4215 226.152 75.2148 223.945 75.2148 221.223V193.757C75.2148 191.034 77.4215 188.828 80.1411 188.828H92.1777C89.4594 188.828 87.2514 191.034 87.2514 193.757V221.223C87.2514 223.945 89.4594 226.152 92.1777 226.152Z",
  fill: "#4F555C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.264 92.9187H150.748C152.294 92.9187 153.549 91.665 153.549 90.1175C153.549 88.5715 152.295 87.3164 150.748 87.3164H86.264C84.7166 87.3164 83.4629 88.5715 83.4629 90.1175C83.4629 91.665 84.7166 92.9187 86.264 92.9187Z",
  fill: "#4F555C"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M86.264 106.91H111.66C113.207 106.91 114.461 105.657 114.461 104.109C114.461 102.563 113.207 101.308 111.66 101.308H86.264C84.7166 101.308 83.4629 102.563 83.4629 104.109C83.4629 105.657 84.7166 106.91 86.264 106.91Z",
  fill: "#4F555C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M122.864 101.308C121.316 101.308 120.062 102.563 120.062 104.109C120.062 105.657 121.316 106.91 122.864 106.91H133.35C134.896 106.91 136.151 105.657 136.151 104.109C136.151 102.563 134.896 101.308 133.35 101.308H122.864Z",
  fill: "#4F555C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M150.748 142.329H86.264C84.7166 142.329 83.4629 143.584 83.4629 145.13C83.4629 146.677 84.7166 147.931 86.264 147.931H150.748C152.294 147.931 153.549 146.677 153.549 145.13C153.549 143.584 152.294 142.329 150.748 142.329Z",
  fill: "#4F555C"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M86.264 161.923H104.642C106.19 161.923 107.443 160.669 107.443 159.121C107.443 157.575 106.19 156.32 104.642 156.32H86.264C84.7166 156.32 83.4629 157.575 83.4629 159.121C83.4629 160.669 84.7166 161.923 86.264 161.923Z",
  fill: "#4F555C"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M86.264 202.943H132.417C133.965 202.943 135.219 201.689 135.219 200.142C135.219 198.596 133.965 197.341 132.417 197.341H86.264C84.7166 197.341 83.4629 198.596 83.4629 200.142C83.4629 201.689 84.7166 202.943 86.264 202.943Z",
  fill: "#4F555C"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M137.076 211.333H119.875C118.328 211.333 117.074 212.588 117.074 214.134C117.074 215.681 118.328 216.935 119.875 216.935H137.076C138.622 216.935 139.877 215.681 139.877 214.134C139.877 212.588 138.622 211.333 137.076 211.333Z",
  fill: "#4F555C"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M108.672 211.333H86.264C84.7166 211.333 83.4629 212.588 83.4629 214.134C83.4629 215.681 84.7166 216.935 86.264 216.935H108.672C110.219 216.935 111.473 215.681 111.473 214.134C111.473 212.588 110.219 211.333 108.672 211.333Z",
  fill: "#4F555C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M200.171 243.574C199.722 243.634 199.27 243.686 198.819 243.731C171.174 246.573 146.457 226.466 143.615 198.818C140.773 171.173 160.88 146.456 188.529 143.614C192.514 143.203 196.443 143.27 200.249 143.77C222.848 146.729 241.301 164.865 243.732 188.528C246.531 215.721 227.121 240.079 200.171 243.574Z",
  fill: "#4F555C"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 158.655,
  cy: 48.6684,
  r: 4.03799,
  fill: "#292F35"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 158.655,
  cy: 48.6684,
  r: 4.03799,
  stroke: "#B0BAC4"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 243.681,
  cy: 153.314,
  r: 4.03799,
  fill: "#292F35"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 243.681,
  cy: 153.314,
  r: 4.03799,
  stroke: "#B0BAC4"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.076,
  cy: 171.523,
  r: 6.07597,
  stroke: "#848D96",
  strokeWidth: 4
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 252.078,
  cy: 97.3987,
  r: 6.07597,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 131.082,
  cy: 45.076,
  r: 6.07597,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M200.195 230.35C199.302 230.51 198.399 230.638 197.484 230.731C196.199 230.862 194.899 230.929 193.617 230.929C194.456 230.929 180.629 232.019 168.789 221.39C161.891 215.202 157.566 206.713 156.618 197.484C154.092 172.894 175.911 152.639 200.236 156.992C207.003 158.198 213.352 161.28 218.562 165.956C225.46 172.145 229.784 180.634 230.733 189.865C232.739 209.383 219.224 226.981 200.195 230.35Z",
  fill: "#40444A"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M215.312 177.903C216.961 179.215 217.234 181.615 215.921 183.264L194.665 209.97C193.361 211.608 190.981 211.889 189.331 210.601L171.89 196.975C170.23 195.678 169.936 193.28 171.233 191.62C172.53 189.959 174.928 189.665 176.588 190.962L191.05 202.26L209.951 178.512C211.263 176.863 213.664 176.59 215.312 177.903Z",
  fill: "#848D96"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 222.97,
  cy: 217.627,
  r: 4.03799,
  fill: "#292F35"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 222.97,
  cy: 217.627,
  r: 4.03799,
  stroke: "#B0BAC4"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.185 115.484C202.349 115.484 201.671 116.162 201.671 116.999V120.027H198.643C197.807 120.027 197.129 120.705 197.129 121.541C197.129 122.378 197.807 123.056 198.643 123.056H201.671V126.084C201.671 126.92 202.349 127.598 203.185 127.598C204.022 127.598 204.7 126.92 204.7 126.084V123.056H207.729C208.565 123.056 209.243 122.378 209.243 121.541C209.243 120.705 208.565 120.027 207.729 120.027H204.7V116.999C204.7 116.162 204.022 115.484 203.185 115.484Z",
  fill: "#B0BAC4"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5878 188.518C37.7515 188.518 37.0735 189.196 37.0735 190.032V193.061H34.0455C33.2092 193.061 32.5312 193.739 32.5312 194.575C32.5312 195.411 33.2092 196.089 34.0455 196.089H37.0735V199.118C37.0735 199.954 37.7515 200.632 38.5878 200.632C39.4241 200.632 40.102 199.954 40.102 199.118V196.089H43.131C43.9673 196.089 44.6452 195.411 44.6452 194.575C44.6452 193.739 43.9673 193.061 43.131 193.061H40.102V190.032C40.102 189.196 39.4241 188.518 38.5878 188.518Z",
  fill: "#4F555C"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M259.869 200.509C259.033 200.509 258.355 201.187 258.355 202.023V205.052H255.327C254.49 205.052 253.812 205.729 253.812 206.566C253.812 207.402 254.49 208.08 255.327 208.08H258.355V211.109C258.355 211.945 259.033 212.623 259.869 212.623C260.705 212.623 261.383 211.945 261.383 211.109V208.08H264.412C265.249 208.08 265.926 207.402 265.926 206.566C265.926 205.729 265.249 205.052 264.412 205.052H261.383V202.023C261.383 201.187 260.705 200.509 259.869 200.509Z",
  fill: "#4F555C"
});

var SvgInvoicesPaidEmptyDark = function SvgInvoicesPaidEmptyDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInvoicesPaidEmptyDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/invoicesPaidEmptyDark.85a4714d.svg";
export { ForwardRef as ReactComponent };